import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import throttle from 'lodash.throttle';
import { useIsDesktopLayout } from '../../hooks/useMediaQuery';
import {
  containerSelector,
  isNativeSelector,
} from '../../redux/reducers/app/params';
import { readCSSVar } from '../../utils/cssVarManipulation';
import FEATURES from '../../constants/featureToggling';

export const useIsFixHeaderEnabled = () => {
  const isDesktop = useIsDesktopLayout();
  const isEnabledFixedHeader = useFeatureIsOn(FEATURES.ENABLE_FIXED_HEADER);

  return isDesktop || !isEnabledFixedHeader;
};

const TIMEOUT = 100;

export const getTotalHeaderHeight = ({ isFixHeaderEnabled, container }) => {
  const DOM_NODE = document.querySelector<HTMLDivElement>(container);
  const hostNavigationHeaderHeight = readCSSVar(
    DOM_NODE,
    '--host-header-height'
  );
  const hostHeaderHeight = DOM_NODE?.offsetTop;
  const headerHeight = readCSSVar(DOM_NODE, '--header-height');

  if (isFixHeaderEnabled) {
    return (
      hostHeaderHeight -
      parseInt(hostNavigationHeaderHeight) +
      parseInt(headerHeight)
    );
  }

  return hostHeaderHeight - parseInt(hostNavigationHeaderHeight);
};

export const useStickySitewideSliderNavWidget = () => {
  const isNative = useSelector(isNativeSelector);

  const isFixHeaderEnabled = useIsFixHeaderEnabled();
  const container = useSelector(containerSelector);

  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    if (isNative) {
      setIsFixed(false);
      return () => {};
    }

    const fixHeader = throttle(() => {
      const totalHeaderHeight = getTotalHeaderHeight({
        isFixHeaderEnabled,
        container,
      });
      setIsFixed(window.scrollY >= totalHeaderHeight);
    }, TIMEOUT);

    window.addEventListener('scroll', fixHeader);
    return () => window.removeEventListener('scroll', fixHeader);
  }, [isNative, setIsFixed, container, isFixHeaderEnabled]);

  return isFixed;
};
